import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/admin/contestants");

export const getIdPath = returnPath("/admin/contestants/:id");
